module.exports = __webpack_public_path__ + "img/changsha_jd_unicom_bsp.c75ada6e.png";